export const DOC_LINK_ROOT =
  "https://natomas.notion.site/Villa-Employee-Software-Guide-73293360522e44afb8cde128a3d8495f";

export const EXTERNAL_LINK_VILLA_INVESTORS =
  "https://villahomes.com/multifamily-investors";
export const EXTERNAL_LINK_VILLA_REALTORS = "https://villahomes.com/compass";

export const EXTERNAL_LINK_VILLA = "https://villahomes.com/";
